module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ua":{"title":"Обмін балів"}}')
  delete Component.options._Ctor
}
